import { Collapse, Group, Paper, Stack, Text } from '@mantine/core';
import { ChevronDownIcon, ChevronRightIcon } from 'lucide-react';
import { useState } from 'react';

const CollapsibleDevPanelSection = ({
  title,
  defaultOpen = false,
  children,
}: {
  title: string;
  defaultOpen?: boolean;
  children: React.ReactNode;
}) => {
  const [opened, setOpened] = useState(defaultOpen);

  return (
    <Stack gap='xs'>
      <Group
        align='center'
        gap='0'
        onClick={() => setOpened(!opened)}
        style={{ cursor: 'pointer' }}
      >
        {opened ? (
          <ChevronDownIcon size={16} />
        ) : (
          <ChevronRightIcon size={16} />
        )}

        <Text fw={600} size='sm' span>
          {title}
        </Text>
      </Group>
      <Collapse in={opened}>
        <Paper withBorder p='sm' mb='md' radius='md'>
          {children}
        </Paper>
      </Collapse>
    </Stack>
  );
};

export default CollapsibleDevPanelSection;
